import React from 'react';
import { motion } from 'framer-motion';
import { FaCertificate, FaAward, FaGraduationCap, FaCheckCircle } from 'react-icons/fa';
import './Certifications.css';

const Certifications = () => {
  const certifications = [
    {
      title: 'ISTQB Certified Tester Foundation Level',
      issuer: 'ISTQB',
      year: '2025',
      icon: <FaCertificate />,
      color: '#3b82f6',
      description: 'Comprehensive software testing fundamentals and best practices'
    },
    {
      title: 'Selenium WebDriver with Python',
      issuer: 'Udemy',
      year: '2022',
      icon: <FaGraduationCap />,
      color: '#10b981',
      description: 'Advanced automation testing with Selenium and Python'
    },
    {
      title: 'API Testing with Postman',
      issuer: 'Postman Academy',
      year: '2022',
      icon: <FaAward />,
      color: '#f59e0b',
      description: 'Complete API testing and automation with Postman'
    }
  ];

  const skills = [
    {
      category: 'Testing Fundamentals',
      courses: [
        'Software Testing Life Cycle (STLC)',
        'Test Case Design Techniques',
        'Defect Management',
        'Agile Testing Methodologies'
      ]
    },
    {
      category: 'Automation Testing',
      courses: [
        'Selenium WebDriver Advanced',
        'PyTest Framework',
        'Page Object Model Design Pattern',
        'CI/CD Integration with Jenkins'
      ]
    },
    {
      category: 'API & Performance',
      courses: [
        'REST API Testing Masterclass',
        'Postman Advanced Features',
        'JMeter Performance Testing',
        'Load Testing Strategies'
      ]
    }
  ];

  return (
    <section id="certifications" className="certifications">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Certifications & Training</h2>
          <p className="section-subtitle">
            Continuous learning and professional development in QA
          </p>
        </motion.div>

        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <motion.div
              key={index}
              className="cert-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -8 }}
            >
              <div className="cert-icon-wrapper" style={{ backgroundColor: `${cert.color}15` }}>
                <div className="cert-icon" style={{ color: cert.color }}>
                  {cert.icon}
                </div>
              </div>
              <div className="cert-content">
                <h3>{cert.title}</h3>
                <div className="cert-meta">
                  <span className="cert-issuer">{cert.issuer}</span>
                  <span className="cert-year">{cert.year}</span>
                </div>
                <p className="cert-description">{cert.description}</p>
              </div>
              <div className="cert-badge" style={{ backgroundColor: cert.color }}>
                Certified
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="training-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        >
          <h3>Additional Training & Courses</h3>
          <div className="training-grid">
            {skills.map((skill, index) => (
              <motion.div
                key={index}
                className="training-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.6 + index * 0.1 }}
              >
                <h4>{skill.category}</h4>
                <ul className="training-list">
                  {skill.courses.map((course, idx) => (
                    <motion.li
                      key={idx}
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.7 + idx * 0.05 }}
                    >
                      <FaCheckCircle className="training-bullet" />
                      {course}
                    </motion.li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="learning-note"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.9 }}
        >
          <FaGraduationCap className="note-icon" />
          <p>
            Committed to continuous learning and staying updated with the latest QA tools, 
            methodologies, and industry best practices.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Certifications;
